// assets
import { IconDashboard, IconUsers, IconFriends, IconAffiliate } from '@tabler/icons';
import logo from "assets/images/logo.png";
// constant
const icons = { IconDashboard, IconUsers, IconFriends, IconAffiliate };


const dashboard = {
    id: 's',
    title: 'Personas',
    type: 'group',
    children: [{
        id: 'persona',
        title: 'Persona',
        type: 'item',
        url: '/home/person',
        icon: icons.IconFriends,
        breadcrumbs: false
    },
    {
        id: 'socio',
        title: 'Socios',
        type: 'item',
        url: '/home/socio',
        icon: icons.IconAffiliate,
        breadcrumbs: false
    },
    {
        id: 'cuentas',
        title: 'Cuentas',
        type: 'item',
        url: '/home/account',
        icon: icons.IconAffiliate,
        breadcrumbs: false
    },
    ]
};

export default dashboard;